export const DISPLAY_TYPES = {
    GRID: 1,
    LIST: 2,
}

export const DEFAULT_DISPLAY_TYPE = DISPLAY_TYPES.LIST;